document.addEventListener("DOMContentLoaded", () => {
const headerGroup = document.querySelector(
      ".shopify-section-group-header-group"
    );

  if (!headerGroup) return;

  document.documentElement.style.setProperty(
    "--header-bottom-position",
    `${parseInt(headerGroup.clientHeight)}px`
  );
});


class Accordion extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector(".acc_headline");
    this.content = this.querySelector(".acc_content");
    this.accordionParent = this.closest(".accordions_parent");
    this.bindElements();
  }

  bindElements() {
    if (this.toggle) {
      this.handleAccordions();
    }
  }

  handleAccordions() {
    this.toggle.addEventListener("click", (event) => {
      let otherAccordions =
        this.accordionParent.querySelectorAll(".acc_headline");

      if (
        otherAccordions &&
        !this.accordionParent.classList.contains("filter-group__options-mobile")
      ) {
        otherAccordions.forEach((acc) => {
          const accContent = acc.nextElementSibling;
          const plusIcon = acc.querySelector(".accordion-plus");
          const minusIcon = acc.querySelector(".accordion--minus");
          const downIcon = acc.querySelector(".menu-accordion-down");

          if (acc !== this.toggle && !accContent.contains(this.toggle)) {
            // collapse acc
            acc.parentElement.ariaExpanded = false;
            if (acc.classList.contains("acc_headline-opened")) {
              acc.classList.remove("acc_headline-opened");
            }
            accContent.classList.remove("acc_content-opened");
            accContent.style.maxHeight = "0px";
            accContent.style.visibility = "hidden";
            accContent.style.overflow = "hidden";
            if (plusIcon && minusIcon) {
              plusIcon.style.display = "block";
              minusIcon.style.display = "none";
            }
            if (downIcon) {
              downIcon.classList.remove("accordion_icon_rotate");
            }
          }
        });
      }

      const content = this.toggle.nextElementSibling;
      const plusIcon = this.toggle.querySelector(".accordion-plus");
      const minusIcon = this.toggle.querySelector(".accordion--minus");
      this.toggle.classList.toggle("acc_headline-opened");
      const downIcon = this.toggle.querySelector(".menu-accordion-down");

      let parent = this.toggle.parentElement;

      if (!content.classList.contains("acc_content-opened")) {
        // Open accordion
        parent.ariaExpanded = true;
        content.classList.add("acc_content-opened");
        content.style.maxHeight = content.scrollHeight + "px";
        content.style.visibility = "visible";
        content.style.visibility = "initial";
        if (plusIcon && minusIcon) {
          plusIcon.style.display = "none";
          minusIcon.style.display = "block";
        }

        if (downIcon) {
          downIcon.classList.add("accordion_icon_rotate");
        }

        // if this accordion is nested inside another accordion, ensure parent can grow
        const currentAccordionEl = this.toggle.closest("accordion-component");
        const parentAccordionEl =
          currentAccordionEl && currentAccordionEl.parentElement
            ? currentAccordionEl.parentElement.closest("accordion-component")
            : null;
        if (parentAccordionEl) {
          const parentContentEl =
            parentAccordionEl.querySelector(".acc_content");
          if (parentContentEl) {
            parentContentEl.style.setProperty(
              "max-height",
              "1200px",
              "important"
            );
            parentContentEl.style.visibility = "visible";
            parentContentEl.style.overflow = "visible";
          }
        }
      } else {
        // Close accordion
        parent.ariaExpanded = false;
        content.classList.remove("acc_content-opened");
        content.style.maxHeight = "0px";
        content.style.visibility = "hidden";
        content.style.overflow = "hidden";
        if (plusIcon && minusIcon) {
          plusIcon.style.display = "block";
          minusIcon.style.display = "none";
        }
        if (downIcon) {
          downIcon.classList.remove("accordion_icon_rotate");
        }
      }
    });
  }
}

customElements.define("accordion-component", Accordion);

// EMBBLA CAROUSEL
// global.js

// ─── HELPER METHODS ───────────────────────────────────────────────────────────

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  if (prevBtn && nextBtn) {
    const toggleState = () => {
      prevBtn.toggleAttribute("disabled", !emblaApi.canScrollPrev());
      nextBtn.toggleAttribute("disabled", !emblaApi.canScrollNext());
    };

    emblaApi
      .on("init", toggleState)
      .on("select", toggleState)
      .on("reInit", toggleState);

    return () => {
      prevBtn.removeAttribute("disabled");
      nextBtn.removeAttribute("disabled");
    };
  }
};

const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  if (prevBtn && nextBtn) {
    const scrollPrev = () => emblaApi.scrollPrev();
    const scrollNext = () => emblaApi.scrollNext();

    prevBtn.addEventListener("click", scrollPrev);
    nextBtn.addEventListener("click", scrollNext);

    const removeToggle = addTogglePrevNextBtnsActive(
      emblaApi,
      prevBtn,
      nextBtn
    );

    return () => {
      removeToggle();
      prevBtn.removeEventListener("click", scrollPrev);
      nextBtn.removeEventListener("click", scrollNext);
    };
  }
};

const addDotBtnsAndClickHandlers = (svgTypeLabel, emblaApi, dotsNode) => {
  let dotNodes = [];
  const svgType = svgTypeLabel || "tear";

  const buildDots = () => {
    const scrollSnaps = emblaApi.scrollSnapList();

    const html = scrollSnaps
      .map((_, index) => {
        const label = `Go to slide ${index + 1}`;
        const controls = `embla__slide--${index + 1}`;

        if (svgType === "line") {
          return `
            <button
              class="embla__dot vertical-line-dot"
              type="button"
              aria-label="${label}"
              aria-controls="${controls}"
            ></button>`;
        } else {
          return `
            <button
              class="embla__dot"
              type="button"
              aria-label="${label}"
              aria-controls="${controls}"
            >
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="white"/>
              </svg>

            </button>`;
        }
      })
      .join("");

    dotsNode.innerHTML = html;

    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    dotNodes.forEach((dot, i) =>
      dot.addEventListener("click", () => emblaApi.scrollTo(i))
    );
  };

  const syncActiveDot = () => {
    const prev = emblaApi.previousScrollSnap();
    const sel = emblaApi.selectedScrollSnap();
    dotNodes[prev]?.classList.remove("embla__dot--selected");
    dotNodes[sel]?.classList.add("embla__dot--selected");
  };

  emblaApi
    .on("init", buildDots)
    .on("reInit", buildDots)
    .on("init", syncActiveDot)
    .on("reInit", syncActiveDot)
    .on("select", syncActiveDot);

  return () => {
    dotsNode.innerHTML = "";
  };
};

const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.scrollTo(index)
  );

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener("click", scrollToIndex[index], false);
  });

  return () => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener("click", scrollToIndex[index], false);
    });
  };
};

const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const toggleThumbBtnsState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[previous].classList.remove("embla-thumbs__slide--selected");
    slidesThumbs[selected].classList.add("embla-thumbs__slide--selected");
  };

  emblaApiMain.on("select", toggleThumbBtnsState);
  emblaApiThumb.on("init", toggleThumbBtnsState);

  return () => {
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[selected].classList.remove("embla-thumbs__slide--selected");
  };
};

// ─── SINGLE CAROUSEL INIT ────────────────────────────────────────────────────

function initEmblaCarousel(emblaNode) {
  const viewport = emblaNode.querySelector(".embla__viewport");
  const prevBtn = emblaNode.querySelector(".embla__button--prev");
  const nextBtn = emblaNode.querySelector(".embla__button--next");

  const dots = emblaNode.querySelector(".embla__dots");
  const svgType = emblaNode.dataset.svg;
  const destroyOnDesktop = emblaNode.dataset.destroyDesktop === "true"; // convert string to boolean
  let emblaApi = null;

  const viewportNodeThumbCarousel = document.querySelector(
    ".embla-thumbs__viewport"
  );

  // Helper function to (re)init or destroy slider based on viewport width
  function handleResize() {
    const isDesktop = window.innerWidth >= 1024; // adjust breakpoint if needed

    // If destroyOnDesktop is true and we're on desktop → destroy if exists
    if (destroyOnDesktop && isDesktop) {
      if (emblaApi) {
        emblaApi.destroy();
        emblaApi = null;
      }
      return;
    }

    // If not initialized yet → init Embla
    if (!emblaApi && viewport) {
      if (viewport.hasAttribute("data-autoplay")) {
        const OPTIONS = { loop: true };
        emblaApi = EmblaCarousel(viewport, OPTIONS, [
          EmblaCarouselAutoplay({ playOnInit: true, delay: 5000 }),
        ]);
      } else if (viewport.hasAttribute("data-thumb")) {
        const OPTIONS_THUMBS = {
          containScroll: "keepSnaps",
          dragFree: true,
        };
        const emblaApiThumb = EmblaCarousel(
          viewportNodeThumbCarousel,
          OPTIONS_THUMBS
        );
        const emblaApiMain = EmblaCarousel(viewport, {});

        const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
          emblaApiMain,
          emblaApiThumb
        );
        const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
          emblaApiMain,
          emblaApiThumb
        );
      } else {
        emblaApi = EmblaCarousel(viewport, { align: "start" });
      }

      if (prevBtn && nextBtn) {
        const removeBtns = addPrevNextBtnsClickHandlers(
          emblaApi,
          prevBtn,
          nextBtn
        );
        emblaApi.on("destroy", removeBtns);
      }
      if (dots) {
        const removeDots = addDotBtnsAndClickHandlers(svgType, emblaApi, dots);
        emblaApi.on("destroy", removeDots);
      }
    }
  }

  // Run once on load
  handleResize();

  // Re-run on resize (debounced for performance)
  window.addEventListener("resize", debounce(handleResize, 200));

  return emblaApi;
}

// Simple debounce helper
function debounce(fn, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(fn, delay);
  };
}

// ─── GLOBAL INIT FUNCTION ───────────────────────────────────────────────────

/**
 * Initializes every `.embla` carousel on the page.
 * Call this again after you replace any carousel markup.
 */
function initAllEmblaCarousels() {
  document.querySelectorAll(".embla").forEach(initEmblaCarousel);
}

// auto-run on initial page load
document.addEventListener("DOMContentLoaded", initAllEmblaCarousels);

// expose for later calls
window.initAllEmblaCarousels = initAllEmblaCarousels;

const addAutoplayProgressListeners = (emblaApi, progressNode) => {
  const progressBarNode = progressNode.querySelector(".embla__progress__bar");

  let animationName = "";
  let timeoutId = 0;
  let rafId = 0;

  const startProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const timeUntilNext = autoplay.timeUntilNext();
    if (timeUntilNext === null) return;

    if (!animationName) {
      const style = window.getComputedStyle(progressBarNode);
      animationName = style.animationName;
    }

    progressBarNode.style.animationName = "none";
    progressBarNode.style.transform = "translate3d(0,0,0)";

    rafId = window.requestAnimationFrame(() => {
      timeoutId = window.setTimeout(() => {
        progressBarNode.style.animationName = animationName;
        progressBarNode.style.animationDuration = `${timeUntilNext}ms`;
      }, 0);
    });

    progressNode.classList.remove("embla__progress--hidden");
  };

  const stopProgress = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    progressNode.classList.add("embla__progress--hidden");
  };

  emblaApi
    .on("autoplay:timerset", startProgress)
    .on("autoplay:timerstopped", stopProgress);

  return () => {
    emblaApi
      .off("autoplay:timerset", startProgress)
      .off("autoplay:timerstopped", stopProgress);
  };
};

const addPlayBtnListeners = (emblaApi, playBtn) => {
  const togglePlayBtnState = (emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const buttonText = autoplay.isPlaying() ? "Start" : "Stop";
    playBtn.innerHTML = buttonText;
  };

  const onPlayBtnClick = () => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const playOrStop = autoplay.isPlaying() ? autoplay.stop : autoplay.play;
    playOrStop();
  };

  playBtn.addEventListener("click", onPlayBtnClick);
  emblaApi
    .on("autoplay:play", togglePlayBtnState)
    .on("autoplay:stop", togglePlayBtnState)
    .on("reInit", togglePlayBtnState);

  return () => {
    playBtn.removeEventListener("click", onPlayBtnClick);
    emblaApi
      .off("autoplay:play", togglePlayBtnState)
      .off("autoplay:stop", togglePlayBtnState)
      .off("reInit", togglePlayBtnState);
  };
};

const addNavBtnListeners = (emblaApi, ...navButtons) => {
  const onNavClick = () => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const resetOrStop =
      autoplay.options.stopOnInteraction === false
        ? autoplay.reset
        : autoplay.stop;

    resetOrStop();
  };

  navButtons.forEach((navButton) =>
    navButton.addEventListener("click", onNavClick, true)
  );

  return () => {
    navButtons.forEach((navButton) =>
      navButton.removeEventListener("click", onNavClick, true)
    );
  };
};

// Readmore
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".readmore-container").forEach((container) => {
    const toggleBtn = container.querySelector(".readmore-toggle");
    const textDiv = container.querySelector(".readmore-text");
    const fullText = textDiv.dataset.fullText;

    if (toggleBtn) {
      toggleBtn.addEventListener("click", () => {
        textDiv.classList.add("expanded");
        textDiv.innerHTML = fullText;

        toggleBtn.style.display = "none";
      });
    }
  });
});

class ReadMoreText extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = this.querySelector(".text__toggle");
    this.toggleLessBtn = this.querySelector(".text__toggle-less");
    this.textData = this.querySelector(".text__data");
  }

  connectedCallback() {
    if (!this.toggleBtn || !this.textData) return;

    let scrollPosition = 0;

    this.toggleBtn.addEventListener("click", () => {
      scrollPosition = window.scrollY;

      this.textData.classList.add("expanded");
      this.toggleBtn.classList.add("hidden");
      this.toggleLessBtn.classList.remove("hidden");
    });

    this.toggleLessBtn.addEventListener("click", () => {
      this.textData.classList.remove("expanded");
      this.toggleBtn.classList.remove("hidden");
      this.toggleLessBtn.classList.add("hidden");

      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    });
  }
}

customElements.define("readmore-text", ReadMoreText);

// Breadcrumbs - once users land on collection page, save the date to localStorage
if (window.location.pathname.includes("/collections/")) {
  localStorage.setItem("last_collection_url", window.location.pathname);
  const collectionTitle = document.querySelector("[data-collection-title]");
  if (collectionTitle) {
    localStorage.setItem(
      "last_collection_title",
      collectionTitle.textContent.trim()
    );
  }
}

if (window.location.pathname == "/") {
  localStorage.removeItem("last_collection_url");
}

// Cart buble count

(() => {
  function setCartCountBubble(count) {
    const bubble = document.querySelector(".cart-count-bubble");
    if (!bubble) return count;

    let num = bubble.querySelector(".cart-count-number");

    if (!num) {
      num = document.createElement("span");
      num.className = "cart-count-number body-xs";
      num.setAttribute("aria-hidden", "true");
      bubble.appendChild(num);
    }
    num.textContent = String(count);

    if (count > 0) {
      bubble.style.display = "flex";
    } else {
      bubble.style.display = "none";
    }

    return count;
  }

  // Globalno dostupno
  window.updateCartCount = async function (input) {
    try {
      let count;

      if (typeof input === "number") {
        count = input;
      } else if (input && typeof input.item_count === "number") {
        // prosledjen cart objekat
        count = input.item_count;
      } else if (input && input instanceof Response) {
        // eventualno prosledjen fetch Response od /cart*.js
        let cart = null;
        try {
          cart = await input.clone().json();
        } catch {}
        if (cart && typeof cart.item_count === "number") {
          count = cart.item_count;
        }
      }

      if (typeof count !== "number") {
        // fallback: povuci /cart.js
        const res = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
        });
        if (!res.ok) return;
        const cart = await res.json();
        count = cart.item_count;
      }

      return setCartCountBubble(count);
    } catch (e) {
      console.warn("updateCartCount error:", e);
    }
  };
})();

document.addEventListener("click", (e) => {
  const closeBtn = document.querySelector(".rh-widget > span");

  if (closeBtn && e.target === closeBtn) {
    let chatClose = document.getElementById("shopify-chat");
    if (chatClose) chatClose.style.visibility = "visible";

    const teaser = document.querySelector('[data-testid="animated-teaser"]');
    if (teaser) teaser.style.display = "";
  }
});

// Product card
if (!customElements.get("product-card")) {
  customElements.define(
    "product-card",
    class ProductCard extends HTMLElement {
      constructor() {
        super();

        this.colors = Array.from(
          this.querySelectorAll(".product-card__color-swatch")
        );

        this.imageEl = this.querySelector(".product-card__image-wrapper img");
        this.initialImage = this.imageEl?.src || null;

        this.priceWrapper = this.querySelector("[data-price-wrapper]");
        this.initialPriceHtml = this.priceWrapper
          ? this.priceWrapper.innerHTML
          : "";
      }

      connectedCallback() {
        this.handleColorHover();
      }

      handleColorHover() {
        if (!this.colors.length || !this.imageEl) return;

        if (window.innerWidth > 767) {
          this.colors.forEach((color) => {
            color.addEventListener("mouseenter", () => {
              const productImage = color.dataset?.image;
              const productPrice = color.dataset?.price;
              const productComparePrice = color.dataset?.compareprice;

              if (productImage) {
                this.imageEl.src = productImage;
                this.imageEl.srcset = "";
              }

              if (!this.priceWrapper || !productPrice) return;

              const hasCompare =
                productComparePrice &&
                productComparePrice.trim() !== "" &&
                productComparePrice !== productPrice;

              if (hasCompare) {
                // compare_at + sale price
                this.priceWrapper.innerHTML = `
                  <span class="price price--on-sale flex justify-between gap-12">
                    <span class="price__compare body-md-semibold">
                      ${productComparePrice}
                    </span>
                    <span class="price__sale body-md-semibold">
                      ${productPrice}
                    </span>
                  </span>
                `;
              } else {
                this.priceWrapper.innerHTML = `
                  <span class="price">
                    <span class="price__regular body-md-semibold">
                      ${productPrice}
                    </span>
                  </span>
                `;
              }
            });

            color.addEventListener("mouseleave", () => {
              if (this.initialImage) {
                this.imageEl.src = this.initialImage;
              }

              if (this.priceWrapper && this.initialPriceHtml) {
                this.priceWrapper.innerHTML = this.initialPriceHtml;
              }
            });
          });
        }
      }
    }
  );
}



document.addEventListener("click", (e) => {
  const a = e.target.closest('a[href*="/discount/BLACK-F15"]');
  if (!a) return;
  localStorage.setItem("discount_code", "BLACK-F15");
});

document.addEventListener("DOMContentLoaded", () => {
  const code = localStorage.getItem("discount_code");

  if (code) {
    const root = document.querySelector(".cart-notification");
    const applied = root.dataset.applied;
    let text = root.querySelector('.cart-notification__count ');
    text.textContent = applied;

    window.openCartNotification();
    localStorage.removeItem("discount_code");
  }
});
